export default __webpack_public_path__ + "static/media/registro_salida_recibo.1e795e47.png";